import { render, staticRenderFns } from "./friendForm.vue?vue&type=template&id=31aa6acc"
import script from "./friendForm.vue?vue&type=script&lang=js"
export * from "./friendForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports